import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {RegexFields} from '../../constants/utils/regexFields';
import * as R from 'ramda';
import {DeleteModal} from './_common/deleteModal';
import {updatePassword, updateUser, uploadProfileImage, deleteProfileImage} from '../../actions/account-api';
import * as Loadings from '../../constants/loadings/account';
import * as Text from '../../constants/translations/account';
import removeAccents from 'remove-accents';

export const General = () => {
	const account = useSelector(state => state.account);
	const dispatch = useDispatch();

	const [modifiedFields, setModifiedFields] = useState({firstName: '',lastName: '', email: '', language: '', phoneNumber: ''});
	const [fileKey, setFileKey] = useState(Date.now());
	const [picture, setPicture] = useState(undefined);
	const [password, setPassword] = useState({current: '', new1: '', new2:''});
	const [passwordNotMatch, setPassswordNotMatch] = useState(false);
	const [emptyPassword, setEmptyPassword] = useState(false);
	const [newPasswordEmpty, setNewPasswordEmpty] = useState(false);
	const [notStrong, setNotStrong] = useState(false);
	const [invalidPassword, setInvalidPassword] = useState(false);

	useEffect(()=>{
		setInvalidPassword(true);
	}, [account.invalidPassword])

	useEffect(() => {
		setModifiedFields({...modifiedFields, firstName: account.user.firstName, lastName: account.user.lastName, email: account.user.email, language: account.user.language, phoneNumber: account.user.phoneNumber});
		// eslint-disable-next-line
	}, [account.user.firstName, account.user.lastName, account.user.email, account.user.language]);

	useEffect(() => {
		if (!R.isNil(password.new1) && password.new1 !== '' && RegexFields.weakPassword.test(password.new1)){
			setNotStrong(true);
		}
		else{
			setNotStrong(false);
		}
		if (newPasswordEmpty === true){
			setNewPasswordEmpty(false);
		}
		if (password.new2 !== '' && (password.new1 !== password.new2)){
			setPassswordNotMatch(true);
		}
		else{
			setPassswordNotMatch(false);
		}
		// eslint-disable-next-line
	}, [password.new2, password.new1]);

	useEffect(() => {
		if (emptyPassword === true && password.current !== ''){
			setEmptyPassword(false);
		}
		// eslint-disable-next-line
	}, [password.current]);

	useEffect(() => {
		setPassword({current: '', new1: '', new2:''});
		// eslint-disable-next-line
	}, [account.user.lastPasswordChangedDate]);

	if (account ===undefined || account.user === undefined){
		return '';
	}

	let currentDate = new Date();
	let timeDiff = Math.abs(currentDate.getTime() - account.user.lastPasswordChangedDate.getTime());
	let diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

	let passwordChangeStatus = Text.LastUpdated[account.user.language];
	if(diffDays > 1){
		passwordChangeStatus = passwordChangeStatus + " " + diffDays + " "+Text.Days[account.user.language];
	}else{
		let diffHours = Math.ceil(timeDiff / (1000 * 3600));
		if(diffHours > 1){
			passwordChangeStatus = passwordChangeStatus + " " + diffHours + " "+ Text.Hours[account.user.language];
		}else{
			let diffMinutes = Math.ceil(timeDiff / (1000 * 60));
			passwordChangeStatus = passwordChangeStatus + " " + diffMinutes + " "+ Text.Minutes[account.user.language];
		}
	}
	if (account.user.language === 'en-EN'){
		passwordChangeStatus = passwordChangeStatus +' ago';
	}

	return (
		<React.Fragment>
			{/* <!-- Apps Section --> */}
			<div className="row g-4 h-inherit">
				<div className="col-md">
					<div className="text-block mb-5" id="section_personalDetails">
						<div className="row mb-1">
							<div className="col">
								<h4 className="h5 mb-0 mt-2">{Text.Account[account.user.language]}</h4>
							</div>
							<div className="col-auto text-right">
								<button className="btn btn-link text-primary collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#personalDetails" aria-expanded="false" aria-controls="personalDetails">{Text.Edit[account.user.language]}</button>
							</div>
						</div>
						<p className="mb-4 mt-0">
							<i className="icns text-muted mdi mdi-badge-account-horizontal-outline mdi-fw mr-2"></i>{account.user.firstName} {account.user.lastName}<br />
							<span className="d-block small o-70 mt-n1 mb-2 ml-4 text-truncate"><i className="icns fw-bold mr-1 align-middle">ID</i>: {account.user.securiboxId}</span>
							<i className="icns text-muted mdi mdi-email-open mdi-fw mr-2"></i>{account.user.email}
							<span className="mx-2 o-20"> | </span>
							<i className="icns text-muted mdi mdi-phone mdi-fw mr-2"></i><span className={!R.isNil(account.user.phoneNumber) && account.user.phoneNumber !== '' ? '' : 'text-muted o-60'}>{!R.isNil(account.user.phoneNumber) && account.user.phoneNumber !== '' ? account.user.phoneNumber : 'N/A'}</span><br />
							<i className="icns text-muted mdi mdi-translate mdi-fw mr-2"></i>{account.user.language === 'fr-FR' ? 'Française' : account.user.language === 'pt-PT' ? 'Português' : 'English'}<br />
						</p>
						<form action="#" className="collapse mb-3" id="personalDetails">
							<div className="row g-3 py-3">
								<div className="form-group col-sm-12">
									<label className="d-inline-block mb-2 form-label" htmlFor="upload-user-photo">{Text.Avatar[account.user.language]}</label>
									<div className="position-relative text-center bg-light rounded-lg p-4" id="avatar">
										<div className="avatar bg-white mb-2 rounded-inherit">
											<i className="img-fluid avatar-img avatar-account account-profile rounded-lg" style={!R.isNil(picture) ? {backgroundImage: "url("+URL.createObjectURL(picture)+")"}: !R.isNil(account.user) && !R.isNil(account.user.pictureUrl) && picture !== null ? {backgroundImage: "url("+account.user.pictureUrl+")"} : undefined}></i>
										</div>
										<input id="upload-user-photo" className="d-none" type="file" accept="image/x-png,image/gif,image/jpeg"  key={fileKey}onInput={(event) => {
											const files = [...event.target.files];
											const file = files[0];
											setPicture(new File([file], removeAccents(file.name).toLowerCase().replace(/\s/gi,"")));
										}} />
										<p className="small text-muted mb-0">{Text.AvatarMessage1[account.user.language]}<br />{Text.AvatarMessage2[account.user.language]} 4MB</p>
										{(picture !== null && picture !== undefined) || (picture === undefined && !R.isNil(account.user) && !R.isNil(account.user.pictureUrl) && account.user.pictureUrl !== null && account.user.pictureUrl !== '') ?
											<button className="btn btn-alert-primary mt-2 lh-1" type="button" onClick={(e) => {
												setPicture(null);
												setFileKey(Date.now());
											}}><i className="icns mdi mdi-close o-60 o-100-hover mr-2"></i>{Text.RemoveAvatar[account.user.language]}</button>
											:
											<label className="stretched-link mb-0" htmlFor="upload-user-photo"></label>
										}
									</div>
								</div>
								<div className="form-group col-sm-sm-8 col-md-6">
									<label className="form-label" htmlFor="nom">{Text.Surname[account.user.language]}</label>
									<input className={"form-control bg-light border-0" + (!R.isNil(modifiedFields.lastName) && !modifiedFields.lastName.match(RegexFields.personName)? ' is-invalid': '')} type="text" name="nom" id="nom" defaultValue={modifiedFields.lastName} onInput={
										(event) => {
											setModifiedFields({...modifiedFields, lastName: event.target.value});
										}
									} />
									<div className="invalid-feedback">
										{Text.EmptyField[account.user.language]}
									</div>
									<div className="d-block small text-muted" role="alert">{Text.YourSecuribox[account.user.language]} <i className="icns fw-bold mr-2">ID</i>{account.user.securiboxId}</div>
								</div>
								<div className="form-group col-sm-8 col-md-6">
									<label className="form-label" htmlFor="surname">{Text.Name[account.user.language]}</label>
									<input className={"form-control bg-light border-0"+ (!R.isNil(modifiedFields.firstName) && !modifiedFields.firstName.match(RegexFields.personName)? ' is-invalid': '')} type="text" name="surname" id="surname" defaultValue={modifiedFields.firstName} onInput={
										(event) => {
											setModifiedFields({ ...modifiedFields, firstName: event.target.value });
										}
									} />
									<div className="invalid-feedback">
										{Text.Name[account.user.language]}
									</div>
								</div>
								<div className="form-group col-sm-8 col-md-6">
									<label className="form-label" htmlFor="email">{Text.EmailAddress[account.user.language]}</label>
									<input className={"form-control bg-light border-0"+ (!R.isNil(modifiedFields.email) && !modifiedFields.email.match(RegexFields.email) ? ' is-invalid': '')} type="email" name="email" id="email" defaultValue={modifiedFields.email} onInput={
										(event) => {
											setModifiedFields({...modifiedFields, email: event.target.value});
										}
									} />
									<div className="invalid-feedback">
									{Text.ValidEmail[account.user.language]}
        							</div>
								</div>
								<div className="form-group col-sm-8 col-md-6">
									<label className="form-label" htmlFor="phone">{Text.Phone[account.user.language]}</label>
									<input className={"form-control bg-light border-0"+ (!R.isNil(modifiedFields.phoneNumber) && !modifiedFields.phoneNumber.match(RegexFields.phone) && modifiedFields.phoneNumber !== ''? ' is-invalid': '')} type="tel" name="phone" id="phone" defaultValue={modifiedFields.phoneNumber} onInput={
										(event) => {
											setModifiedFields({...modifiedFields, phoneNumber: event.target.value});
										}
									} />
									<div className="invalid-feedback">
									{Text.ValidPhone[account.user.language]}
        							</div>
								</div>
								<div className="col-12">
									<hr className="o-100 mb-1"/>
								</div>
								<div className="form-group col-sm-6">
									<label className="form-label" htmlFor="lang">{Text.Language[account.user.language]}</label>
									<div className="form-dropdown">
										<select className="form-control bg-light border-0" name="lang" id="lang" tabIndex={-98} value={modifiedFields.language} onChange={
											(event) => {
												setModifiedFields({ ...modifiedFields, language: event.target.value });
											}
										}>
											<option value="en-EN">English</option>
											<option value="fr-FR">Française</option>
											{/* <option value="pt-PT">Português</option> */}
										</select>
									</div>
								</div>
							</div>
							<button className={"btn btn-primary mb-4 mr-2"+(account.isLoading.includes(Loadings.UPDATE_USER) || account.isLoading.includes(Loadings.UPDATE_PICTURE) ? ' disabled': '')} type="submit" onClick={
								(event) => {
									event.preventDefault();
										if ((!account.isLoading.includes(Loadings.UPDATE_USER) && !account.isLoading.includes(Loadings.UPDATE_PICTURE))  && (modifiedFields.firstName !== account.user.firstName ||
											modifiedFields.lastName !== account.user.lastName ||
											modifiedFields.email !== account.user.email ||
											modifiedFields.language !== account.user.language ||
											modifiedFields.phoneNumber !== account.user.phoneNumber)){
											dispatch(updateUser(modifiedFields));
											if(picture !== undefined && picture !== null){
												dispatch(uploadProfileImage(picture));
											}
										}
										if ((!account.isLoading.includes(Loadings.UPDATE_USER) && !account.isLoading.includes(Loadings.UPDATE_PICTURE)) && picture !== undefined && picture !== null){
											dispatch(uploadProfileImage(picture));
										}
										else if((!account.isLoading.includes(Loadings.UPDATE_USER) && !account.isLoading.includes(Loadings.UPDATE_PICTURE)) && picture === null){
											dispatch(deleteProfileImage());
										}
								}
							}>{Text.UpdateAccount[account.user.language]}</button>
							<button className="btn btn-dim mb-4 mr-2" type="button" data-bs-toggle="collapse" data-bs-target="#personalDetails" aria-expanded="false" aria-controls="personalDetails">{Text.Cancel2[account.user.language]}</button>
						</form>
					</div>
					<div className="text-block mb-5" id="section_updatePassword">
						<div className="row mb-1">
							<div className="col">
								<h4 className="h5 mb-0 mt-2">{Text.Password[account.user.language]}</h4>
							</div>
							<div className="col-auto text-right">
								<button className="btn btn-link text-primary" type="button" data-bs-toggle="collapse" data-bs-target="#updatePassword" aria-expanded="true" aria-controls="updatePassword">{Text.Edit[account.user.language]}</button>
							</div>
						</div>
						<p className="text-muted mb-4 mt-0">
							{diffDays > 30 && 
								<span className="badge rounded-1 py-2 bg-alert-warning border-none align-middle">⚠️</span>
							}
							<span className="align-middle ml-2">{passwordChangeStatus}</span>
							
						</p>
						<div className="collapse mb-3" id="updatePassword">
							<input className="sr-only" type="text" id="username" name="username" autoComplete="username email" value="" onChange={() => {}} />
							<div className="row mt-4">
								<div className="form-group col-sm-12">
									<label className="form-label" htmlFor="password-current">{Text.CurrentPassword[account.user.language]}</label>
									<input className={"form-control bg-light border-0" + (emptyPassword === true ? ' is-invalid' : '')} type="password" autoComplete="current-password" name="password-current" id="password-current" value={password.current} onChange={
										(event) => {
											setInvalidPassword(false);
											setPassword({...password, current: event.target.value});
										}
									} />
									<div className="invalid-feedback">
										{emptyPassword  === true ? Text.EmptyField[account.user.language] : ''}
        							</div>
								</div>
								<div className="form-group col-sm-md-6">
									<label className="form-label" htmlFor="password-new">{Text.NewPassword[account.user.language]}</label>
									<input className={"form-control bg-light border-0" + (newPasswordEmpty === true || notStrong === true ? ' is-invalid' : '')} type="password" autoComplete="new-password" name="password-new" id="password-new" value={password.new1} onChange={
										(event) => {
											setInvalidPassword(false);
											setPassword({...password, new1: event.target.value});
										}
									}/>
									<div className="invalid-feedback">
										{newPasswordEmpty === true ? <>{Text.EmptyField[account.user.language]}</>: notStrong ? <>{Text.PasswordRequirements1[account.user.language]} <strong>8</strong> {Text.PasswordRequirements2[account.user.language]} S3cur1b0#, Secur1bo%, $3curibox</> : ''}
        							</div>
								</div>
								<div className="form-group col-sm-md-6">
									<label className="form-label" htmlFor="password-confirm">{Text.ConfirmPassword[account.user.language]}</label>
									<input className={"form-control bg-light border-0" + (passwordNotMatch === true ? ' is-invalid' : '')} type="password" autoComplete="new-password" name="password-confirm" id="password-confirm" value={password.new2} onChange={
										(event) => {
											setInvalidPassword(false);
											setPassword({ ...password, new2: event.target.value });
										}
									} />
									<div className="invalid-feedback">
										{Text.PasswordsDoNotMatch[account.user.language]}
									</div>
								</div>
							</div>
							{
								account.invalidPassword !== undefined && invalidPassword === true ?
									<span className="small text-warning mt-n1 d-block"><i className="icns mdi mdi-alert mdi-fw mr-2"></i>
										{Text[account.invalidPassword][account.user.language]}
									</span> : ''
							}
							<br/>
							<button className={"btn btn-primary mb-4 mr-2 " + (account.isLoading.includes(Loadings.UPDATE_PASSWORD) ? ' disabled': '')} onClick={
								(event) => {
									event.preventDefault();
									if (!account.isLoading.includes(Loadings.UPDATE_PASSWORD)){
										if (password.current === '') {
											setEmptyPassword(true)
										}
										else {
											if (password.new1 === ''){
												setNewPasswordEmpty(true);
											}
											else if (password.new1 !== '' && password.new1 !== password.new2) {
												setPassswordNotMatch(true);
											}
											else if (password.new1 !== '' && password.new1 === password.new2){
												dispatch(updatePassword(password));
											}
										}
									}
								}
							 }>{Text.UpdatePassword[account.user.language]}</button>
							 <button className="btn btn-dim mb-4 mr-2" type="button" data-bs-toggle="collapse" data-bs-target="#updatePassword" aria-expanded="false" aria-controls="updatePassword">{Text.Cancel2[account.user.language]}</button>
						</div>
					</div>
					<div className="text-block mb-5" id="section_supprimer">
						<div className="row mb-1">
							<div className="col-9">
								<h4 className="h5 mb-0 mt-2">{Text.Delete[account.user.language]}</h4>
							</div>
							<div className="col text-right">
								<button className="btn btn-link text-info" type="button" data-bs-toggle="tooltip" data-placement="top" title="This action cannot be undone"><i className="icns mdi mdi-information-outline h4 lh-1"></i></button>
							</div>
						</div>
						<ul className="text-muted pl-4 mb-4">
							<p className="text-body ml-n4 mb-0">{Text.DeleteMessage1[account.user.language]}</p>
							<li>{Text.DeleteMessage2[account.user.language]}</li>
							<li>{Text.DeleteMessage3[account.user.language]}</li>
							<li>{Text.DeleteMessage4[account.user.language]}</li>
						</ul>
						<button className="btn btn-delete px-4" data-bs-toggle="modal" data-bs-target="#accountRemove"><i className="icns mdi mdi-trash-can-outline h5 align-middle ml-n1 mr-2"></i>{Text.DeleteButton[account.user.language]}</button>
					</div>
				</div>
				<div className="col-md-4 col-xl-3 ml-lg-auto">
					{/* <!-- Feature Section --> */}
					<div className="alert alert-info p-0 mb-4">
						<div className="container-fluid">
							<div className="row align-items-lg-center">
								<div className="col order-md-last">
									<svg className="img-fluid py-4 pt-lg-0 d-block container-tiny container-md-tight mx-auto" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 560 620"><ellipse cx="283" cy="605.7228" fill="currentColor" opacity=".15" rx="277" ry="14" /><path fill="currentColor" d="M14.0667636 205.3228c-5.01202987.019503-9.65280421-2.639504-12.17053715-6.973307-2.51773293-4.333803-2.52896747-9.682352-.02946283-14.026693 17.79999998-30 71.89999998-100.1 190.10000038-100.1 51.2 0 96.1 13.6 133.4 40.4 30.7 22 47.9 46.9 56.1 58.9 2.100198 3.057586 2.890835 6.827916 2.195897 10.47164-.694937 3.643725-2.817764 6.858394-5.895897 8.92836-6.448434 4.321467-15.170779 2.674902-19.6-3.7-14.9-21.6-60.1-87.2-166.2-87.2-103.6000004 0-150.4000004 60.4-165.7000004 86.3-2.4837611 4.385625-7.1603542 7.068917-12.2 7z" opacity=".25" /><path fill="currentColor" d="M251.466764 479.723969c-1.178891.014103-2.354954-.120304-3.5-.401169-85.7-21.5-117.7-108.1-119-111.7l-.2-.8c-.7-2.5-17.9-61.9 8.5-96.7 12.1-15.9 30.5-24 54.8-24 22.6 0 38.9 7.1 50.1 21.8 9.2 12 12.9 26.8 16.5 41.1 7.5 29.7 12.9 45.3 44.1 46.9 13.7.7 22.7-7.4 27.8-14.3 13.8-18.8 16.2-49.5 5.8-76.5-13.4-35-60.8-100.9-144.4-100.9-35.7 0-68.5 11.6-94.8000004 33.4-21.8 18.1-39.1 43.6-47.4 69.8-15.4 48.8 4.8 125.5 5 126.2.9494144 3.581314.4265897 7.393612-1.4519318 10.587099-1.8785214 3.193486-4.9565871 5.502702-8.5480682 6.412901-7.5028744 1.980237-15.206196-2.428023-17.3-9.9-.9-3.5-22.49999998-85.3-4.7-141.7 19.4-61.10005 79.2000004-122.7 169.2000004-122.7 41.6 0 80.9 14.3 113.7 41.3 25.4 21 46.2 49.2 57 77.4 13.8 36 10.1 76.4-9.4 102.8-13 17.6-31.5 26.8-52 25.8-53.4-2.7-63-40.4-70-67.9-7.2-28.2-11.8-41.8-39.3-41.8-15.1 0-25.7 4.2-32.3 12.9-9 11.9-9.7 30.5-8.7 44 .01.141.0202.281727.0306.42218 1.323005 17.175077 6.523496 33.826543 15.21027 48.70181 13.88212 23.93614 42.04092 60.64529 88.75913 72.37601 3.603228.872482 6.708204 3.149086 8.623903 6.323137 1.915699 3.17405 2.483162 6.982172 1.576097 10.576853-1.670173 6.193098-7.285647 10.496929-13.7 10.501179z" opacity=".25" /><path fill="currentColor" d="M141.466764 473.322802c-3.890266 0-7.611959-1.587778-10.3-4.400002-34.3000004-36.4-53.7000004-77.1-61.0000004-128v-.3c-4.1-33.7 1.9-81.4 31.3000004-114.2 21.7-24.2 52.2-36.5 90.5-36.5 45.3 0 80.9 21.3 103.1 61.5 10.03283 18.48784 16.607213 38.651541 19.4 59.5.685669 7.694192-4.936228 14.512243-12.6201 15.305241-7.683872.792997-14.579729-4.733187-15.4799-12.405241-2.432698-17.432027-8.024178-34.274242-16.5-49.7-17.2-30.7-43.4-46.3-78-46.3-29.9 0-53.3 9.1-69.4 27.1-23.2000004 25.9-27.7000004 65.8-24.5000004 92.2 6.4000004 45 23.5000004 80.8 53.7000004 112.8 2.546716 2.691927 3.906709 6.293212 3.775117 9.996578-.131591 3.703366-1.74376 7.199041-4.475117 9.703422-2.59871 2.368024-5.984228 3.686594-9.5 3.700002z" opacity=".25" /><circle cx="192.166764" cy="324.7228" r="18" fill="currentColor" opacity=".25" /><path fill="#FFB9B9" d="M484.3782 232.1652s30.24614-.44137 23.80221 8.65362c-6.44393 9.09499-31.44446 8.45972-31.44446 8.45972l7.64225-17.11334z" /><path fill="#EFA02E" d="M391.3407 120.01079l30.60963 41.55779 26.46415 31.61723s27.42027 28.603 30.47831 32.55875c3.05804 3.95575 12.0425 2.82459 10.13026 8.85313-1.91224 6.02854-4.766 16.07125-7.7511 17.11492-2.9851 1.04367-17.01278-.75185-18.04186-2.737-1.02908-1.98515-66.57662-39.03273-89.96813-65.69426l-22.262-15.11-.33393-25.56466 40.67467-22.5959z" /><path fill="#000" d="M391.3407 120.01079l30.60963 41.55779 26.46415 31.61723s27.42027 28.603 30.47831 32.55875c3.05804 3.95575 12.0425 2.82459 10.13026 8.85313-1.91224 6.02854-4.766 16.07125-7.7511 17.11492-2.9851 1.04367-17.01278-.75185-18.04186-2.737-1.02908-1.98515-66.57662-39.03273-89.96813-65.69426l-22.262-15.11-.33393-25.56466 40.67467-22.5959z" opacity=".1" /><path fill="#191847" d="M384.52362 0h.00009c25.694302 0 46.52365 20.8293476 46.52365 46.52365v46.5238H338V46.52366C338 20.8293576 358.829348 0 384.52365 0h-.00003z" /><path fill="#FFB9B9" d="M352.31907346 120.29311475l14.58156003-58.00979602c-6.68987585-8.4701459-11.16602581-18.63296382-10.05116007-29.89294625C360.2943204.01677617 405.4015822 8.83832492 413.7952091 25.42018134c8.19507726 16.72043105 5.7692794 58.12651218-5.67066906 60.79611657-4.51845944.93911664-14.24398771-2.16443078-23.91210039-8.55595585l4.62758324 43.86487237-36.52094942-1.23209968z" /><path fill="#191847" d="M409.255 36.444h-41.792L358 12h58.352zM300.5 484.2228s-9 12-9 15-5 4-8 7-6 2-4 5-25 21-25 21l-26 34 7 6 20-21-3 37 28 26s12 2 13 0-10-22-10-22 1-18 7-25c3.721547-4.376802 7.06677-9.060114 10-14 0 0-3-4 4-5s2-7 2-7 2-1 8-1 33-29 33-29l-47-27zM412.5 515.2228s-4 14 3 22 0 6 0 6 1 6-3 9-4 9-4 9-5 10-4 16 1 36 1 36h10v-26l20 26h50s-1-5-6-6-20 0-23-21c0 0-1-12-3-14s-4-9-2-14 0-7 3-9 4-8 2-11-8-8-1-11 7-18 7-18l-50 6z" /><path fill="#1F28CF" d="M346.5 275.2228s-11 9 3 46 20 85 20 85-14 12-14 18-62 44-58 61 77 49 84 47 41-98 41-98-13-106-14-107-31-50-31-50l-18-37-13 35z" /><path fill="#000" d="M346.5 275.2228s-11 9 3 46 20 85 20 85-14 12-14 18-62 44-58 61 77 49 84 47 41-98 41-98-13-106-14-107-31-50-31-50l-18-37-13 35z" opacity=".1" /><path fill="#1F28CF" d="M345.5 252.2228s-8 29 11 59 41 92 41 92 21 65 12 112c0 0-3 6 5 6s92-2 85-23-38-119-38-119l-40-99-2-30-15-23h-31l-28 25z" /><path fill="#FFB9B9" d="M205.60886 282.2228s-30.24936 0-23.67342 9c6.57594 9 31.564554 8 31.564554 8l-7.891134-17z" /><path fill="#EFA02E" d="M392 98.7228s-31-9-32-12-8 4-11 9-9 11-12 11-25 13-30 36c-2.28888 10.52884-5.62556 16.65695-8.57106 20.207-2.213817 2.899604-3.560099 6.36749-3.88265 10.00131-.029944.341691-.237463.642422-.54629.79167-2 1 42 43 42 43s17-4 20 0-2 11-5 15-10 24-6 27 25-27 37-21 24 1 24 1 5 16 13 16 10-13 7-17-15-12-9-23 8-31 8-31 16-19-13-42c0 0-10-28-13-30s-8-3-8-5 1-7.99998 1-7.99998z" /><path fill="#191847" d="M384.52371 53.676879l5.419484 45.6514008L338 93.04745V46.52366C338 20.8293576 358.829348 0 384.52365 0c25.694362 0 .00006 27.9825766.00006 53.676879z" /><path fill="#EFA02E" d="M297 168.7228l-30 42-26 32s-27 29-30 33-12 3-10 9 5 16 8 17 17-1 18-3 66-40 89-67l22.03912-15.43319L338 190.7228l-41-22z" /><path fill="#191847" d="M357.59206 217.80017l57.96608 1.84974c1.360221.040625 2.44186 1.155013 2.44186 2.51584v.92487c0 .687072-.280895 1.344275-.777475 1.819117-.49658.474843-1.165691.726046-1.852075.695323l-57.96608-2.7746c-1.344939-.060243-2.40437-1.168153-2.40437-2.51444 0-.680561.275607-1.332114.763962-1.806111.488355-.473996 1.147839-.730034 1.828098-.709739z" /><ellipse cx="417" cy="223.2228" fill="#2F2E41" rx="1" ry="5.5" /></svg>
								</div>
								<div className="col-12 col-sm-6 col-md-12 mb-7 mb-lg-3">
									<div className="pt-4 pt-md-3">
										<h5 className="h5 mb-2 subtitle">{Text.HowWeUseInfo[account.user.language]}</h5>
										<p className="o-60 card-text mb-0"><strong>{Text.NameAndSurname[account.user.language]}</strong></p>
										<p className="o-60 card-text">{Text.NameSurnameDesc[account.user.language]}</p>
										<p className="o-60 card-text mb-0"><strong>{Text.EmailAddress[account.user.language]}</strong></p>
										<p className="o-60 card-text">{Text.EmailAddressDesc[account.user.language]}</p>
									</div>
								</div>
								{/* <p className="o-60 small card-text m-3 mt-lg-2">Consequat <strong>exercitation culpa laboris</strong>  fugiat non ipsum veniam Lorem aliqua deserunt tempor elit veniam.</p> */}
							</div>
						</div>
					</div>
					{/* <!-- End Feature Section --> */}
					{/* <div className="card mb-4">
						<div className="card-header px-0 pt-0" id="headingTwo">
							<div className="flex-row align-items-center align-middle">
								<div className="flex-column align-middle">
									<h4 className="h4 mb-0">{Text.HelpWithAccount[account.user.language]}</h4>
								</div>
								<i className="icns mdi mdi-lifebuoy h4 mb-0 align-middle"></i>
							</div>
						</div>
						<hr className="mt-0 border-faded" />
						<ul className="list-unstyled small">
							<a className="text-left text-cc" href="securibox.eu" target="_blank" rel="noopener noreferrer"><li><i className="icns mdi mdi-link mr-2 h5 align-middle text-primary"></i>{Text.GetHelp[account.user.language]}</li></a>
							<a className="text-left text-cc" href="securibox.eu" target="_blank" rel="noopener noreferrer"><li><i className="icns mdi mdi-link mr-2 h5 align-middle text-primary"></i>{Text.ChangeEmail[account.user.language]}</li></a>
							<a className="text-left text-cc" href="securibox.eu" target="_blank" rel="noopener noreferrer"><li><i className="icns mdi mdi-link mr-2 h5 align-middle text-primary"></i>{Text.ProtectAccount[account.user.language]}</li></a>
							<a className="text-left text-cc" href="securibox.eu" target="_blank" rel="noopener noreferrer"><li><i className="icns mdi mdi-link mr-2 h5 align-middle text-primary"></i>{Text.CloseAccount[account.user.language]}</li></a>
							<a className="text-left text-cc" href="securibox.eu" target="_blank" rel="noopener noreferrer"><li><i className="icns mdi mdi-link mr-2 h5 align-middle text-primary"></i>{Text.Hiring[account.user.language]}</li></a>
						</ul>
					</div> */}
				</div>
			</div>
			{/* <!-- End Apps Section --> */}
			<DeleteModal/>
		</React.Fragment>
	)
}